var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile2User = function SvgProfile2User(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5800",
    d: "M8.25 1.834a4.36 4.36 0 0 0-4.354 4.354c0 2.356 1.842 4.262 4.244 4.345a.7.7 0 0 1 .201 0h.065a4.343 4.343 0 0 0 4.198-4.345A4.36 4.36 0 0 0 8.25 1.834",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5800",
    d: "M12.907 12.97c-2.558-1.704-6.728-1.704-9.304 0-1.164.78-1.806 1.834-1.806 2.961 0 1.128.642 2.173 1.797 2.943 1.283.862 2.97 1.293 4.656 1.293 1.687 0 3.374-.431 4.657-1.293 1.155-.78 1.797-1.824 1.797-2.96-.01-1.128-.642-2.173-1.797-2.943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5800",
    d: "M18.325 6.728a3.28 3.28 0 0 1-2.87 3.548h-.045c-.055 0-.11 0-.156.018-.89.046-1.705-.238-2.32-.76A4.2 4.2 0 0 0 14.31 6.05a4.26 4.26 0 0 0-.706-1.999 3.293 3.293 0 0 1 4.72 2.677",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5800",
    d: "M20.158 15.208c-.074.889-.642 1.659-1.595 2.181-.917.504-2.072.743-3.218.715.66-.596 1.045-1.338 1.118-2.126.092-1.137-.449-2.228-1.53-3.099a7.6 7.6 0 0 0-2.109-1.155c2.026-.587 4.574-.192 6.142 1.073.843.678 1.274 1.53 1.192 2.41"
  })));
};
export default SvgProfile2User;